import './legacy';
import './polyfills/hidden';
import './modules/sticky-header';
import './modules/home-carousel';
import './modules/hero-gallery';
import './modules/draws';
import './modules/filter';
import './modules/billing-address';
import './modules/booking-bar/index';
import './modules/nav-list';
import './modules/forms';
import './modules/quick-jump';
import './modules/cookie-notice';
import './modules/ticker';
import './modules/product-filter';
import './modules/product-tabs';
import './modules/add-to-basket';
import './modules/update-cart';
import './modules/commerce-header-a11y';
import './modules/commerce/product-variants';
import './modules/commerce/product-ajax';
import './modules/commerce/grocery-delivery';
import { init as carousel } from './modules/commerce/product-index';
import { init as orderItems } from './modules/order-summary';
import { init as groceryShippingMethod } from './modules/grocery-shipping-method';
import { init as spinbutton } from './modules/spinbutton';
import { init as billingAddress } from './modules/billing-address';
import { domapi } from '@rynpsc/dialog';
import LazyLoader from './modules/lazy-loader';

init();

function init() {
	carousel();
	orderItems();
	groceryShippingMethod();
	billingAddress();
	spinbutton();
	domapi();
	LazyLoader().update();

  const accordion = document.querySelectorAll('.accordion-toggle');

  accordion.forEach(element => {
    const wrapper = element.nextElementSibling;

    element.addEventListener('click', function() {
      if (element.classList.contains('open')) {
        element.classList.remove('open');
        wrapper.classList.add('hidden');
      } else {
        element.classList.add('open');
        wrapper.classList.remove('hidden');
      }
    });
  });
}
